<div>
	<p>
		{{'labels.hours-resources-explanation' | translate}}
		<span *ngIf="project?.isDraft">
			{{'labels.hours-resources-explanation2' | translate}}
		</span>
	</p>
</div>

<div
	#tablearea
	class="tablearea">

	<div
		class="row"
		*ngIf="loading">
		<div class="icon-loading">
			<span>
				<i class="fa fa-circle-notch fa-spin fa-2x"></i>
			</span>

		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && !resources?.length">
		<div class="col text-center  p-5">
			{{'labels.no-resources' | translate}}
			<a (click)="gotoResources()">
				{{'labels.assign-resources' | translate}}
			</a>

		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && resources && resources.length">
		<div class="col-sm-12 mb-3">
			<a
				class="fullscreen-pointer"
				(click)="toggleFullscreen()">

				<i
					ngbTooltip="fullscreen"
					class="fas fa-{{tablefull ? 'compress' : 'expand'}}-arrows-alt"></i>

			</a>

			<small
				class="edit-alert"
				*ngIf="selectedResource && selectedMonth !== undefined">
				{{ 'labels.changehoursresources'| translate:{resource: selectedResource.fullname, month: selectedMonth} }}
				<a (click)="dosave()">{{ 'labels.close'| translate}}</a>

			</small>

			<small
				class="edit-alert"
				*ngIf="selectedResource && selectedMonth === undefined">
				Stai modificando il costo orario del dipendente {{selectedResource.fullname}}
				<a (click)="dosave()">{{ 'labels.close'| translate}}</a>

			</small>
			<div class="scroll-container">
				<table
					class="table-matrix fullscreen-table"
					cellspacing="0"
					cellpadding="0">
					<thead>
						<tr>
							<th></th>
							<ng-template
								ngFor
								let-obj
								let-i="index"
								[ngForOf]="months">

								<th class="rotate">

									<div>
										<span>m{{i}}</span>
									</div>
								</th>

							</ng-template>
							<th class="rotate">
								<div>
									<span>Tot.</span>
								</div>
							</th>
							<th class="rotate">
								<div>
									<span>Costo</span>
								</div>
							</th>
						</tr>

					</thead>
					<tbody>
						<tr *ngFor="let r of resources; let ri = index">
							<td
								class="names"
								[ngClass]="{'hover': hoverr==ri}">
								<div class="name">{{r.fullname}}</div>
							</td>
							<ng-template
								ngFor
								let-m
								let-i="index"
								[ngForOf]="months">
								<td
									(mouseenter)="hoverr=ri; hoverc=i"
									(mouseleave)="hoverr=undefined; hoverc=undefined"
									[ngClass]="{'active' : r['m'+i]>0, 'hover': hoverr==ri || hoverc ==i}"
									class="checkbox"
									(click)="activateInput(r,i)">
									<span>
										<input
											#inputfield
											(focusout)="activateInput()"
											(keydown.enter)="activateInput()"
											(keydown.tab)="tab(r,i,ri)"
											type="text"
											*ngIf="selectedResource?.id == r.id  && selectedMonth == i"
											[(ngModel)]="r['m'+i]">
										<span
											class="table-value"
											*ngIf="selectedResource?.id != r.id  || selectedMonth != i">
											{{r['m'+i]}}
										</span>
									</span>

								</td>

							</ng-template>
							<td
								[ngClass]="{'hover': hoverr==ri}"
								class="tot">
								{{r.tot}}
							</td>
							<td
								[ngClass]="{'hover': hoverr==ri}"
								class="hourlycost"
								(click)="select(r)">
								<span
									[ngbTooltip]="tooltip2"
									[disableTooltip]="selectedResource && selectedMonth == undefined">
									<span
										class="table-value"
										*ngIf="selectedResource?.id != r.id || selectedMonth != undefined">
										{{r.actualcost ||  r.employee.hourlycost}}
									</span>
									<input
										*ngIf="selectedResource?.id == r.id  && selectedMonth == undefined"
										#inputfield
										(focusout)="dosave()"
										(keydown.enter)="dosave()"
										type="text"
										size="200"
										[(ngModel)]="r.actualcost">
								</span>
								<ng-template #tooltip2>
									<span *ngIf="!r.actualcost">
										Costo orario dipendente - modifica per sovrascrivere per il progetto
									</span>
									<span *ngIf="r.actualcost">Costo orario dipendente per il progetto</span>
								</ng-template>
							</td>
						</tr>
					</tbody>

				</table>

			</div>
		</div>
	</div>
</div>
